import { render } from "./NewsCardView.vue?vue&type=template&id=0dc5c068&scoped=true"
import script from "./NewsCardView.vue?vue&type=script&lang=js"
export * from "./NewsCardView.vue?vue&type=script&lang=js"

import "./NewsCardView.vue?vue&type=style&index=0&id=0dc5c068&scoped=true&lang=scss"

import exportComponent from "D:\\Code\\MonsterView\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0dc5c068"]])

export default __exports__